export const addLeadingZero = (v: string | number) => {
  return `'0${v}`.slice(-2);
};
